// extracted by mini-css-extract-plugin
export default {"toolbar":"OrdersToolbar_toolbar__sMje3","title":"OrdersToolbar_title__8e2fB"};